import React, { useEffect, useState } from 'react';
import useNewsArticles from '../hooks/useNewsArticles';
import _ from 'lodash';
import INew from '../interfaces/INewsArticle';
import CNewsArticle from '../components/CNewsArticle';
type VNewsArticleLastDashboardProps = {
	size: 'small' | 'medium';
};
const VNewsArticleLastDashboard = (props: VNewsArticleLastDashboardProps) => {
	const { size } = props;
	const { data: news } = useNewsArticles();

	const [lastNew, setLastNew] = useState<INew | null>(null);
	useEffect(() => {
		if (news) {
			const newsTmp = _.orderBy(news, ['creation'], ['desc']);
			setLastNew(newsTmp && newsTmp.length > 0 ? newsTmp[0] : null);
		} else {
			setLastNew(null);
		}
	}, [news]);

	return <>{lastNew ? <CNewsArticle article={lastNew} size={size} /> : <></>}</>;
};

export default VNewsArticleLastDashboard;
